export const DISC_PROPERTY_TYPES = [
    { value: 1, label: 'BeatUp' },
    { value: 2, label: 'Extra Glide' },
    { value: 3, label: 'Big Skip' },
    { value: 4, label: 'Sticky' },
    { value: 5, label: 'Accurate' },
    { value: 6, label: 'Heavy' },
    { value: 7, label: 'Light' },
    { value: 8, label: 'Wind Break' },
    { value: 9, label: 'Fade' },
    { value: 10, label: 'Turn' },
    { value: 11, label: 'Roll' },
    { value: 12, label: 'Water Skip' },
];

export const MANUFACTURER_NAMES = [
    { value: 1, label: 'Latitude 64' },
    { value: 2, label: 'Westside Discs' },
    { value: 3, label: 'Dynamic Discs' },
    { value: 4, label: 'Discmania' },
    { value: 5, label: 'Kastaplast' },
    { value: 6, label: 'Discraft' },
    { value: 7, label: 'Prodigy' },
    { value: 8, label: 'Spinoff' },
    { value: 9, label: 'MVP Discs' },
    { value: 10, label: 'Axiom Discs' },
    { value: 11, label: 'Streamline Discs' },
];

export const MOULD_NAMES = [
    { value: 1, label: 'Dagger', manufacturer: 1 },
    { value: 2, label: 'Old Compass', manufacturer: 1 },
    { value: 3, label: 'Explorer', manufacturer: 1 },
    { value: 4, label: 'Fuse', manufacturer: 1 },
    { value: 5, label: 'Pure', manufacturer: 1 },
    { value: 6, label: 'River', manufacturer: 1 },
    { value: 7, label: 'Musket', manufacturer: 1 },
    { value: 8, label: 'Keystone', manufacturer: 1 },
    { value: 9, label: 'Old Anchor', manufacturer: 1 },
    { value: 10, label: 'Old Pioneer', manufacturer: 1 },
    { value: 11, label: 'Recoil', manufacturer: 1 },
    { value: 12, label: 'Old Ballista', manufacturer: 1 },
    { value: 13, label: 'XXX', manufacturer: 1 },
    { value: 14, label: 'Old Saint Pro', manufacturer: 1 },
    { value: 15, label: 'Havoc', manufacturer: 1 },
    { value: 16, label: 'Old Ballista Pro', manufacturer: 1 },
    { value: 17, label: 'Underworld', manufacturer: 2 },
    { value: 18, label: 'Warship', manufacturer: 2 },
    { value: 19, label: 'Emac Truth', manufacturer: 3 },
    { value: 20, label: 'Emac Judge', manufacturer: 3 },
    { value: 21, label: 'Escape', manufacturer: 3 },
    { value: 22, label: 'Old Tilt', manufacturer: 4 },
    { value: 23, label: 'RazorClaw', manufacturer: 4 },
    { value: 24, label: 'Link', manufacturer: 4 },
    { value: 25, label: 'Instinct', manufacturer: 4 },
    { value: 26, label: 'Sapphire', manufacturer: 1 },
    { value: 27, label: 'Faith', manufacturer: 1 },
    { value: 28, label: 'Trust', manufacturer: 1 },
    { value: 29, label: 'Old Grace', manufacturer: 1 },
    { value: 30, label: 'Rive', manufacturer: 1 },
    { value: 31, label: 'Raider', manufacturer: 2 },
    { value: 32, label: 'Harp', manufacturer: 2 },
    { value: 33, label: 'Mercy', manufacturer: 1 },
    { value: 34, label: 'Cloud Breaker DD3', manufacturer: 4 },
    { value: 35, label: 'Rask', manufacturer: 5 },
    { value: 36, label: 'Lots', manufacturer: 5 },
    { value: 37, label: 'Berg', manufacturer: 5 },
    { value: 38, label: 'Glory', manufacturer: 1 },
    { value: 39, label: 'Old Flow', manufacturer: 1 },
    { value: 40, label: 'Hope', manufacturer: 1 },
    { value: 41, label: 'Sky God', manufacturer: 4 },
    { value: 42, label: 'Felon', manufacturer: 3 },
    { value: 43, label: 'Stag', manufacturer: 2 },
    { value: 44, label: 'Maiden', manufacturer: 2 },
    { value: 45, label: 'Agent', manufacturer: 3 },
    { value: 46, label: 'Tursas', manufacturer: 2 },
    { value: 47, label: 'Old Saint', manufacturer: 1 },
    { value: 48, label: 'Queen', manufacturer: 2 },
    { value: 49, label: 'DD3', manufacturer: 4 },
    { value: 50, label: 'PD', manufacturer: 4 },
    { value: 51, label: 'P2', manufacturer: 4 },
    { value: 52, label: 'Fury', manufacturer: 1 },
    { value: 53, label: 'Marshal', manufacturer: 3 },
    { value: 54, label: 'Sword', manufacturer: 2 },
    { value: 55, label: 'Claymore', manufacturer: 1 },
    { value: 56, label: 'Stiletto', manufacturer: 1 },
    { value: 57, label: 'Falk', manufacturer: 5 },
    { value: 58, label: 'Stal', manufacturer: 5 },
    { value: 59, label: 'Guld', manufacturer: 5 },
    { value: 60, label: 'Jarn', manufacturer: 5 },
    { value: 61, label: 'Svea', manufacturer: 5 },
    { value: 62, label: 'Gote', manufacturer: 5 },
    { value: 63, label: 'Kaxe', manufacturer: 5 },
    { value: 64, label: 'Reko', manufacturer: 5 },
    { value: 65, label: 'Reko X', manufacturer: 5 },
    { value: 66, label: 'Shield', manufacturer: 5 },
    { value: 67, label: 'Swan 1 Reborn', manufacturer: 2 },
    { value: 68, label: 'Swan 2', manufacturer: 2 },
    { value: 69, label: 'Anvil', manufacturer: 2 },
    { value: 70, label: 'Gatekeeper', manufacturer: 2 },
    { value: 71, label: 'Ahti', manufacturer: 2 },
    { value: 72, label: 'Bear', manufacturer: 2 },
    { value: 73, label: 'Hatchet', manufacturer: 2 },
    { value: 74, label: 'King', manufacturer: 2 },
    { value: 75, label: 'Destiny', manufacturer: 2 },
    { value: 76, label: 'Sorcerer', manufacturer: 2 },
    { value: 77, label: 'Zeus', manufacturer: 6 },
    { value: 78, label: 'Luna', manufacturer: 6 },
    { value: 79, label: 'Athena', manufacturer: 6 },
    { value: 80, label: 'Savior', manufacturer: 1 },
    { value: 81, label: 'Hades', manufacturer: 6 },
    { value: 82, label: 'Malta', manufacturer: 6 },
    { value: 83, label: 'Anax', manufacturer: 6 },
    { value: 84, label: 'Stig', manufacturer: 5 },
    { value: 85, label: 'Krut', manufacturer: 5 },
    { value: 86, label: 'Sockibomb Slammer', manufacturer: 3 },
    { value: 87, label: 'Core', manufacturer: 1 },
    { value: 88, label: 'Rainmaker', manufacturer: 4 },
    { value: 89, label: 'Old Honor', manufacturer: 1 },
    { value: 90, label: 'Vandal', manufacturer: 3 },
    { value: 91, label: 'Cloud Breaker 2022', manufacturer: 4 },
    { value: 92, label: 'Captain', manufacturer: 3 },
    { value: 93, label: 'Bounty', manufacturer: 3 },
    { value: 94, label: 'Enforcer', manufacturer: 3 },
    { value: 95, label: 'Judge', manufacturer: 3 },
    { value: 96, label: 'Essence', manufacturer: 4 },
    { value: 97, label: 'Origin', manufacturer: 4 },
    { value: 98, label: 'Crab', manufacturer: 8 },
    { value: 99, label: 'Evidence', manufacturer: 3 },
    { value: 100, label: 'Sampo', manufacturer: 2 },
    { value: 101, label: 'FX2', manufacturer: 7 },
    { value: 102, label: 'PA1', manufacturer: 7 },
    { value: 103, label: 'Archive', manufacturer: 7 },
    { value: 104, label: 'X1', manufacturer: 7 },
    { value: 105, label: 'Spike', manufacturer: 1 },
    { value: 106, label: 'Avenger SS', manufacturer: 6 },
    { value: 107, label: 'Raptor', manufacturer: 6 },
    { value: 108, label: 'Challenger', manufacturer: 6 },
    { value: 109, label: 'FD3', manufacturer: 4 },
    { value: 110, label: 'MD1', manufacturer: 4 },
    { value: 111, label: 'Adder', manufacturer: 2 },
    { value: 112, label: 'Paradigm', manufacturer: 4 },
    { value: 113, label: 'Logic', manufacturer: 4 },
    { value: 114, label: 'Brave', manufacturer: 1 },
    { value: 115, label: 'Strive', manufacturer: 1 },
    { value: 116, label: 'Maverick', manufacturer: 3 },
    { value: 117, label: 'Enigma', manufacturer: 4 },
    { value: 118, label: 'FD', manufacturer: 4 },
    { value: 119, label: 'Trespass', manufacturer: 3 },
    { value: 120, label: 'MD3', manufacturer: 4 },
    { value: 121, label: 'CD1', manufacturer: 4 },
    { value: 122, label: 'Bolt', manufacturer: 1 },
    { value: 123, label: 'Vanguard', manufacturer: 4 },
    { value: 124, label: 'Mutant', manufacturer: 4 },
    { value: 125, label: 'Culverin', manufacturer: 1 },
    { value: 126, label: 'MD5', manufacturer: 4 },
    { value: 127, label: 'Defender', manufacturer: 3 },
    { value: 128, label: 'P2x', manufacturer: 4 },
    { value: 129, label: 'Guard', manufacturer: 3 },
    { value: 130, label: 'Prince', manufacturer: 2 },
    { value: 131, label: 'General', manufacturer: 2 },
    { value: 132, label: 'Longbowman', manufacturer: 2 },
    { value: 133, label: 'Truth', manufacturer: 3 },
    { value: 134, label: 'PD2', manufacturer: 4 },
    { value: 135, label: 'Evader', manufacturer: 3 },
    { value: 136, label: 'DD', manufacturer: 4 },
    { value: 137, label: 'DD1', manufacturer: 4 },
    { value: 138, label: 'FD1', manufacturer: 4 },
    { value: 139, label: 'Splice', manufacturer: 4 },
    { value: 140, label: 'Drop', manufacturer: 2 },
    { value: 141, label: 'Tactic', manufacturer: 4 },
    { value: 142, label: 'TD', manufacturer: 4 },
    { value: 143, label: 'Glacier', manufacturer: 1 },
    { value: 144, label: 'Sweep', manufacturer: 1 },
    { value: 145, label: 'Peak', manufacturer: 1 },
    { value: 146, label: 'Fugitive', manufacturer: 3 },
    { value: 147, label: 'Notion', manufacturer: 4 },
    { value: 148, label: 'Vass', manufacturer: 5 },
    { value: 149, label: 'Idog', manufacturer: 4 },
    { value: 150, label: 'Diamond', manufacturer: 1 },
    { value: 151, label: 'Sinus', manufacturer: 5 },
    { value: 152, label: 'Pine', manufacturer: 5 },
    { value: 153, label: 'World', manufacturer: 1 },
    { value: 154, label: 'Crown', manufacturer: 1 },
    { value: 155, label: 'Fortress', manufacturer: 6 },
    { value: 156, label: 'Halo', manufacturer: 6 },
    { value: 157, label: 'Thief', manufacturer: 3 },
    { value: 158, label: 'Magician', manufacturer: 4 },
    { value: 159, label: 'Jade', manufacturer: 1 },
    { value: 160, label: 'Jury', manufacturer: 3 },
    { value: 161, label: 'Getaway', manufacturer: 3 },
    { value: 162, label: 'Tide', manufacturer: 2 },
    { value: 163, label: 'Sheriff', manufacturer: 3 },
    { value: 164, label: 'DD2', manufacturer: 4 },
    { value: 165, label: 'Compass', manufacturer: 1 },
    { value: 166, label: 'Saint', manufacturer: 1 },
    { value: 167, label: 'Saint Pro', manufacturer: 1 },
    { value: 168, label: 'Anchor', manufacturer: 1 },
    { value: 169, label: 'Grace', manufacturer: 1 },
    { value: 170, label: 'Flow', manufacturer: 1 },
    { value: 171, label: 'Pioneer', manufacturer: 1 },
    { value: 172, label: 'Honor', manufacturer: 1 },
    { value: 173, label: 'Ballista', manufacturer: 1 },
    { value: 174, label: 'Ballista Pro', manufacturer: 1 },
    { value: 175, label: 'Phase World', manufacturer: 4 },
    { value: 176, label: 'DD3 Premier', manufacturer: 4 },
    { value: 177, label: 'FD2', manufacturer: 4 },
    { value: 178, label: 'Seer', manufacturer: 4 },
    { value: 179, label: 'Treason', manufacturer: 3 },
    { value: 180, label: 'Warhorse', manufacturer: 2 },
    { value: 181, label: 'P4', manufacturer: 4 },
    { value: 182, label: 'Tilt', manufacturer: 4 },
    { value: 183, label: 'Alva', manufacturer: 1 },
    { value: 184, label: 'Heist', manufacturer: 3 },
    { value: 185, label: 'Sling', manufacturer: 2 },
    { value: 186, label: 'Tuff', manufacturer: 5 },
    { value: 187, label: 'Warrant', manufacturer: 3 },
    { value: 188, label: 'Deputy', manufacturer: 3 },
    { value: 189, label: 'DD1 Premier', manufacturer: 4 },
    { value: 190, label: 'FD Premier', manufacturer: 4 },
    { value: 899, label: 'Spore', manufacturer: 4 },
    { value: 900, label: 'Bite', manufacturer: 1 },
    // { value: 901, label: 'Spinoff Disc 1' },
    // { value: 902, label: 'Marlin' },
    // { value: 903, label: 'Manta' },
    // { value: 904, label: 'Yggdrasil' },
    // { value: 905, label: 'Midgard' },
    // { value: 906, label: 'Alfheim' },
    { value: 907, label: 'Margherita', manufacturer: 8 },
    { value: 908, label: 'Quattro Formaggi', manufacturer: 8 },
    { value: 909, label: 'Kaos', manufacturer: 8 },
    { value: 910, label: 'Pixel Halo', manufacturer: 8 },
    { value: 911, label: 'Pixel Fortress', manufacturer: 8 },
    { value: 912, label: 'Pixel Sword', manufacturer: 8 },
    { value: 913, label: 'Pixel Peak', manufacturer: 8 },
    { value: 914, label: 'Precious DD3', manufacturer: 8 },
    { value: 915, label: 'Mudskip', manufacturer: 8 },
    { value: 916, label: 'Proto Glide', manufacturer: 8 },
    { value: 917, label: 'Proto Batic', manufacturer: 8 },
    // { value: 997, label: 'GodMode' },
    // { value: 998, label: 'TestDisc' },
    // { value: 999, label: 'MenuDisc' },
    { value: 1000, label: 'Watt', manufacturer: 9 },
    { value: 1100, label: 'Tempo', manufacturer: 10 },
    { value: 1101, label: 'Rhythm', manufacturer: 10 },
    { value: 1200, label: 'Parachute', manufacturer: 11 },
    { value: 1201, label: 'Shift', manufacturer: 11 },
];

export const DISC_STAMP_NAMES = [
    { value: 1, label: 'Stock Stamp' },
    { value: 2, label: 'Keith Tour Series' },
    { value: 3, label: 'Tattar Tour Series' },
    { value: 4, label: 'Tamm Tour Series' },
    { value: 5, label: 'McCray Tour Series' },
    { value: 6, label: 'Lehtinen Tour Series' },
    { value: 7, label: 'Tanner Tour Series' },
    { value: 8, label: 'Cox Tour Series' },
    { value: 9, label: 'Latt Tour Series' },
    { value: 10, label: 'Jarnes Tour Series' },
    { value: 11, label: 'DDO 2021' },
    { value: 12, label: 'Trilogy Challenge Judge' },
    { value: 13, label: 'Trilogy Challenge Saphire' },
    { value: 14, label: 'Trilogy Challenge Warship' },
    { value: 15, label: 'Ricky 2022' },
    { value: 16, label: 'Kona 2022' },
    { value: 17, label: 'Tattar 2022' },
    { value: 18, label: 'Linus 2022' },
    { value: 19, label: 'Lauri 2022' },
    { value: 20, label: 'Ricky Harp 2022' },
    { value: 21, label: 'Linus Trust 2022' },
    { value: 22, label: 'Lauri Pioneer 2022' },
    { value: 23, label: 'JohnE Fuse 2022' },
    { value: 24, label: 'JohnE BP 2022' },
    { value: 25, label: 'Luke 2022' },
    { value: 26, label: 'Kymen 2022' },
    { value: 27, label: 'Berg K2' },
    { value: 28, label: 'Albert Ballista 2022' },
    { value: 29, label: 'Albert Pioneer 2022' },
    { value: 30, label: 'Keiti Sapphire 2022' },
    { value: 31, label: 'Keiti Hope 2022' },
    { value: 32, label: 'Tristan Rive 2022' },
    { value: 33, label: 'Tristan Faith 2022' },
    { value: 34, label: 'Gavin Truth 2022' },
    { value: 35, label: 'DDO 2022' },
    { value: 36, label: 'Silver Lätt Glory 2022' },
    { value: 37, label: 'Silver Lätt Rive 2022' },
    { value: 38, label: 'Connor O Rive 2022' },
    { value: 39, label: 'Connor O Faith 2022' },
    { value: 40, label: 'Emerson K Explorer 2022' },
    { value: 41, label: 'Emerson K Ballista 2022' },
    { value: 42, label: 'Rebecca Cox Glory 2022' },
    { value: 43, label: 'Rebecca Cox Grace 2022' },
    { value: 44, label: 'Matty O Stag 2022' },
    { value: 45, label: 'Matty O Maiden 2022' },
    { value: 46, label: 'Trilogy Challenge Agent 2022' },
    { value: 47, label: 'Trilogy Challenge Tursas 2022' },
    { value: 48, label: 'Trilogy Challenge Saint 2022' },
    { value: 49, label: 'Erika Sword' },
    { value: 50, label: 'Erika Marshal' },
    { value: 51, label: 'Tattar Pure 2023' },
    { value: 52, label: 'Tattar Grace 2023' },
    { value: 53, label: 'Albert Ballista 2023' },
    { value: 54, label: 'Albert Trust 2023' },
    { value: 55, label: 'Linus Carlsson Savior 2023' },
    { value: 56, label: 'Linus Carlsson Rive 2023' },
    { value: 57, label: 'John E McCray Fuse 2023' },
    { value: 58, label: 'JohnE McCray Saint 2023' },
    { value: 59, label: 'Guld DGV' },
    { value: 60, label: 'Sapphire 2023' },
    { value: 61, label: 'Keiti Tatte Sapphire 2023' },
    { value: 62, label: 'Latitude64 Ballista Pro 2023' },
    { value: 63, label: 'Latitude64 Claymore 2023' },
    { value: 64, label: 'Latitude64 Flow 2023' },
    { value: 65, label: 'DynamicDiscs Raider 2023' },
    { value: 66, label: 'DynamicDiscs Felon 2023' },
    { value: 67, label: 'DynamicDiscs Marshal 2023' },
    { value: 68, label: 'Berg Slammer 2023' },
    { value: 69, label: 'Ricky Wysocki Slammer 2023' },
    { value: 70, label: 'Ricky Wysocki Raider 2023' },
    { value: 71, label: 'Keiti Tatte Core 2023' },
    { value: 72, label: 'Luke Samson Krut 2023' },
    { value: 73, label: 'Glow Area 64' },
    { value: 74, label: 'Glow Dragon' },
    { value: 75, label: 'Glow Jelly' },
    { value: 76, label: 'Silver Latt Rive 2023' },
    { value: 77, label: 'Silver Latt Explorer 2023' },
    { value: 78, label: 'RebeccaCox Glory 2023' },
    { value: 79, label: 'RebeccaCox Honor 2023' },
    { value: 80, label: 'Eagle McMahon Rainmaker 2023' },
    { value: 81, label: 'Eagle McMahon CloudBreaker 2023' },
    { value: 82, label: 'Luke Samson RekoX 2023' },
    { value: 83, label: 'MattyO Stag 2023' },
    { value: 84, label: 'MattyO Enforcer 2023' },
    { value: 85, label: 'Ikigai Champion 3 Stars' },
    { value: 86, label: 'MP Reward Track S2 Glow Ballista' },
    { value: 87, label: 'MP Reward Track S2 Glow River' },
    { value: 88, label: 'Berg Legacy' },
    { value: 89, label: 'MP Reward Track S3 Glow Tursas' },
    { value: 90, label: 'MP Reward Track S3 Glow Origin' },
    { value: 91, label: 'MP Reward Track S4 Glow Rask' },
    { value: 92, label: 'MP Reward Track S4 Glow Spike' },
    { value: 93, label: 'Felon Fuzion' },
    { value: 94, label: 'Bounty Lucid Glimmer' },
    { value: 95, label: 'Shield Dead' },
    { value: 96, label: 'I Know The Truth' },
    { value: 97, label: 'Trick Or Treat' },
    { value: 98, label: 'Winter Pack 2023 Logic' },
    { value: 99, label: 'Winter Pack 2023 Bear' },
    { value: 100, label: 'Winter Pack 2023 Destiny' },
    { value: 101, label: 'MP Reward Track S5 Glow Luna' },
    { value: 102, label: 'MP Reward Track S5 Glow Adder' },
    { value: 103, label: 'Dragon Pack Essence' },
    { value: 104, label: 'Reese Worlds' },
    { value: 105, label: 'Christmas Spirit' },
    { value: 106, label: 'A Grinch At Heart' },
    // { value: 107, label: 'Aligment Stamp' },
    // { value: 108, label: 'Blackie Foil' },
    // { value: 109, label: 'Blackie Rim' },
    { value: 110, label: 'MP Reward Track S6 Glow Pure' },
    { value: 111, label: 'MP Reward Track S6 Glow Warship' },
    { value: 112, label: 'MP Reward Track S6 Glow Destiny' },
    { value: 113, label: 'MP Reward Track S6 Enigma' },
    { value: 114, label: 'DGV Pro Tour 1' },
    { value: 115, label: 'DGV Pro Tour 2' },
    { value: 116, label: 'DGV Pro Tour 3' },
    { value: 117, label: 'Latitude Royal Cup' },
    { value: 118, label: 'Up All Night' },
    { value: 119, label: 'Latitude 64 Stamp' },
    { value: 120, label: 'FREE SLOT' },
    { value: 121, label: 'Kristin Tattar 2024 Grace' },
    { value: 122, label: 'Kristin Tattar 2024 Pure' },
    { value: 123, label: 'Linus Carlsson 2024 Compass' },
    { value: 124, label: 'Linus Carlsson 2024 Strive' },
    { value: 125, label: 'Silver Latt 2024 Rive' },
    { value: 126, label: 'Jakub S 2024 Ballista Pro' },
    { value: 127, label: 'Jakub S 2024 Brave' },
    { value: 128, label: 'Gold Master 2023 Reward' },
    { value: 129, label: 'Diamond Master 2023 Reward' },
    { value: 130, label: 'Champion Landing Master 2022 Reward' },
    { value: 131, label: 'Beast Master 2022 Reward' },
    { value: 132, label: 'MP Reward Track S7 Glow Disc 3' },
    { value: 133, label: 'MP Reward Track S7 Glow Disc 5' },
    { value: 134, label: 'Charlie Stamp' },
    { value: 135, label: 'Gannon B 2024 MD5' },
    { value: 136, label: 'Gannon B 2024 Prototype' },
    { value: 137, label: 'Alden H 2024 Mutant' },
    { value: 138, label: 'Alden H 2024 FD3' },
    { value: 139, label: 'Kyle K 2024 Logic' },
    { value: 140, label: 'Kyle K 2024 Vanguard' },
    { value: 141, label: 'Ella H 2024 FD' },
    { value: 142, label: 'Ella H 2024 Origin' },
    { value: 144, label: 'Champion Landing Master 2024 Reward' },
    { value: 144, label: 'Champion Landing Master 2024 Reward 1' },
    { value: 145, label: '2024 DDO Challenge' },
    { value: 146, label: 'Red Master 2023 Reward' },
    { value: 147, label: 'MP Reward Track S9 Berg Stamp' },
    { value: 148, label: 'MP Reward Track S9 Hope Stamp' },
    { value: 149, label: 'MP Reward Track S9 Escape Stamp' },
    { value: 150, label: 'MP Reward Track S9 Adder Stamp' },
    { value: 151, label: 'Westside Kids Queen' },
    { value: 152, label: 'Simon Stamp' },
    { value: 153, label: 'Ricky Wysocki General 2024' },
    { value: 154, label: 'Ricky Wysocki Truth 2024' },
    { value: 155, label: 'Kona Montgomery Trespass 2024' },
    { value: 156, label: 'Kona Montgomery Maverick 2024' },
    { value: 157, label: 'Matt Orum Prince 2024' },
    { value: 158, label: 'Matt Orum Sampo 2024' },
    { value: 159, label: 'Sai Ananda Longbowman 2024' },
    { value: 160, label: 'Sai Ananda Harp 2024' },
    { value: 161, label: 'MP Reward Track S8 Glow Queen' },
    { value: 162, label: 'MP Reward Track S9 KP Svea Stamp' },
    { value: 163, label: 'MP Reward Track S9 KP Lots Stamp' },
    { value: 164, label: 'MP Reward Track S9 KP Guld Stamp' },
    { value: 165, label: 'MP Reward Track S9 Discmania Stamp' },
    { value: 166, label: 'Lucky Reward' },
    { value: 167, label: 'Halloween 2024 Medusa' },
    { value: 168, label: 'Halloween 2024 Mummy' },
    { value: 169, label: 'Halloween 2024 Scarecrow' },
    { value: 170, label: 'Glow Pack 2024 Alien' },
    { value: 171, label: 'Glow Pack 2024 DGV' },
    { value: 172, label: 'Glow Pack 2024 Necro' },
    { value: 173, label: 'MVP Open Rhythm' },
    { value: 174, label: 'MVP Open Watt' },
    { value: 175, label: 'MVP Open Parachute' },
    { value: 176, label: 'MVP Open Shift' },
    { value: 177, label: 'MVP Open Tempo' },
    { value: 178, label: 'Gold Master 2024 Reward' },
    { value: 179, label: 'Quirky Reward' },
];

export const DISC_BAG_NAMES = [
    { value: 0, label: 'Default' },
    { value: 1, label: 'Random' },
    { value: 2, label: 'Draft' },
    { value: 3, label: 'Basic' },
    { value: 4, label: 'Putters' },
    { value: 5, label: 'Big Skip' },
    { value: 6, label: 'Balanced' },
    { value: 7, label: 'Rollers' },
    { value: 8, label: 'Royal' },
    { value: 9, label: 'Hops And Hyzer' },
    { value: 10, label: 'Glow' },
    { value: 11, label: 'TeamSeries 2023 b1' },
    { value: 12, label: 'TeamSeries 2023 b2' },
    { value: 13, label: 'Team Series 2023 b3' },
    { value: 14, label: 'Trilogy Challenge 2023' },
    { value: 15, label: 'Halloween 2023' },
    { value: 16, label: 'Foundation Bag' },
    { value: 17, label: 'Water Skip' },
    { value: 18, label: 'Tilts Only' },
    { value: 19, label: 'MVP Open 24' },
    { value: 20, label: 'Discmania' },
    { value: 21, label: 'Dynamic Discs' },
    { value: 22, label: 'Kastaplast' },
    { value: 23, label: 'Westside Discs' },
    { value: 24, label: 'Latitude 64' },
    { value: 25, label: 'House of Discs 2025' },
    { value: 26, label: 'Pizza Bag' },
    { value: 27, label: 'Sunny Bag' },
    { value: 28, label: 'Darkpoi' },
    { value: 29, label: 'DGVTips' },
    { value: 30, label: 'Bamananam' },
    { value: 100, label: 'Trilogy Challenge' },
];

export const REWARD_OPTIONS = [
    { value: 0, label: 'None' },
    // { value: 1, label: 'Random Distance' },
    // { value: 4, label: 'Random Fairway' },
    // { value: 5, label: 'Random Midrange' },
    // { value: 7, label: 'Random Putter' },
    { value: 6, label: 'Random Disc Choice' },
    { value: 2, label: 'Custom Disc' },
];

export const DISC_STAMP_TYPES = [
    { value: 0, label: 'Stock Stamp' },
    { value: 1, label: 'Built-in Stamp' },
    { value: 2, label: 'Firebase Stamp' },
];

export const DISC_COLORS = [
    'Black1',
    'Black2',
    'Black3',
    'Blue1',
    'Blue2',
    'Blue3',
    'DarkBlue1',
    'DarkBlue2',
    'DarkBlue3',
    'DarkGreen1',
    'DarkGreen2',
    'Green1',
    'Green2',
    'Green3',
    'LightRed1',
    'LightRed2',
    'LightRed3',
    'Lime1',
    'Orange1',
    'Orange2',
    'Pink1',
    'Red1',
    'Red2',
    'Red3',
    'Teal1',
    'White1',
    'White2',
    'White3',
    'Yellow1',
    'Yellow2',
    'DarkGreen3',
    'BlueBlack1',
    'BlueBlack2',
    'BlueBurst1',
    'BlueYellow1',
    'FireBurst1',
    'GreenBurst1',
    'GreenBurst2',
    'GreyBurst1',
    'GreyBurst2',
    'OrangeBlack1',
    'PinkBurst1',
    'RedBlack1',
    'RedBlack2',
    'RedBurst1',
    'WhiteBlue1',
    'Heavenly',
    'Burst',
    'TPPink',
    'TPGrey',
    'TPBlue',
    'ChristmasBurst',
    'DDO1',
    'BlackRecycled1',
    'BlueRecycled1',
    'BlueRecycled2',
    'DarkGreenRecycled1',
    'GreenRecycled1',
    'GreenRecycled2',
    'LightRedRecycled1',
    'OrangeRecycled1',
    'PinkRecycled1',
    'RedRecycled1',
    'RedRecycled2',
    'TealBlue1',
    'TealBlue2',
    'WhiteRecycled1',
    'YellowRecycled1',
    'Chroma1',
    'Chroma2',
    'Chroma3',
    'BlueGlimmer',
    'PinkGlimmer',
    'PurpleGlimmer',
    'WhiteGlimmer',
    'BlackGlimmer',
    'DarkBlueGlimmer',
    'Ice1',
    'Ice2',
    'Ice3',
    'Ice10_2',
    'OrbitBlack',
    'OrbitBlue',
    'OrbitGold',
    'OrbitRed',
    'GreenGlow',
    'GreenGlow02',
    'RoyalBlue',
    'RoyalBlue2',
    'RoyalGreen',
    'RoyalGrey',
    'RoyalOrange',
    'RoyalOrange1',
    'RoyalPink',
    'RoyalPink2',
    'RoyalRed',
    'RoyalBlack',
    'RoyalBlack1',
    'RoyalBlue3',
    'RoyalPink2 1',
    'K1_blue',
    'K1_green',
    'K1_green2',
    'K1_green3',
    'K1_green4',
    'K1_orange',
    'K1_pink',
    'K1_purple',
    'K1_red',
    'K1_red2',
    'K1_turquoise',
    'K1_turquoise2',
    'K1_white',
    'K1_yellow',
    'K1_yellow2',
    'Guld_DGV',
    'MintGreen_DGV',
    'Bagger',
    'BatPurp',
    'Eye',
    'FrogBlue',
    'FrogGreen',
    'HeartRed',
    'Hops',
    'LeafGreen 1',
    'LeafGreen',
    'Monster',
    'Mouth',
    'Rauta',
    'SkullBlue',
    'SkullRed',
    'WebGreen',
    'WebPurple',
    'WolfBlue',
    'WolfGrey',
    'Reese',
    'TCJudge',
    'TCSapphire',
    'TCWarship',
    'EagleInstinct',
    'EagleRazor',
    'SimonLink',
    'SimonTilt',
    'Ice7',
    'Ice8',
    'Ice9',
    'Ice4',
    'Ice5',
    'Ice6',
    'RickRaider',
    'LinusRive',
    'LauriMercy',
    'KonaEscape',
    'KristinGrace',
    'RickHarp',
    'KristinGrace2',
    'KonaEscape2',
    'LinusTrust',
    'LauriPioneer',
    'EagleCB',
    'EagleRC2',
    'SimonSG',
    'SimonTilt2',
    'JohnEFuse',
    'JohnEBP',
    'KymenBerg',
    'KymenLots',
    'LukeBerg',
    'LukeRask',
    'TristanRive2022',
    'TristanFaith2022',
    'KeitiSapphire2022',
    'KeitiHope2022',
    'gavinFelon2022',
    'gavinThruth2022',
    'albertPioneer2022',
    'albertBallista2022',
    'SilverLattGlory2022',
    'SilverLattRive2022',
    'ConnorOFaith2022',
    'ConnorORive2022',
    'EmersonKBallista2022',
    'EmersonKExplorer2022',
    'RebeccaCGlory2022',
    'RebeccaCGrace2022',
    'MattyOMaiden2022',
    'MattyOStag2022',
    'TC2022Agent',
    'TC2022Saint',
    'TC2022Tursas',
    'TheBeast2022Open',
    'TheBeast2022Final',
    'EdgeBlue',
    'EdgeGold',
    'EdgeGreen',
    'Hops_Barrel_2022',
    'Hops_FnF_2022',
    'Hops_MM_2022',
    'Hops_TnT_2022',
    'ErikaMarshal2022',
    'ErikaSword2022',
    'Halloween2022Pumpkin',
    'Halloween2022Skull',
    'Halloween2022Wolf',
    'HalloweenEvent2022Pumpkin',
    'HalloweenEvent2022Skull',
    'HalloweenEvent2022Zombie',
    'FTO_Fury',
    'FTO_Harp',
    'Christmas2022Mountain',
    'Christmas2022Package',
    'Christmas2022Reindeer',
    'Christmas2022SantaThrow',
    'Christmas2022Snowman',
    'Christmas2022StrongSanta',
    'Christmas2022GingerBreadman',
    'Kristin2023Grace',
    'Kristin2023PureGlow',
    'albertBallista2023',
    'albertTrust2023',
    'JohnE2023SaintPro',
    'JohnE2023Fuse',
    'Linus2023Rive',
    'Linus2023Savior',
    'Linus2023Savior',
    'Easter2023_BallistaPro',
    'Easter2023_Grace',
    'Easter2023_Fuse',
    'SeasonBegins2023_Raider',
    'SeasonBegins2023_Instinct',
    'SeasonBegins2023_Warship',
    'WestsidePack1_2023_King',
    'WestsidePack1_2023_Hatchet',
    'WestsidePack1_2023_Shield',
    'Spring2023_Sorcerer',
    'Black4',
    'RickyW2023Slammer',
    'RickyW2023Raider',
    'PaulMcBeth2023Luna',
    'PaulMcBeth2023Zeus',
    'Keiti2023Sapphire',
    'Keiti2023Core',
    'Luke2023Krut',
    'Luke2023RekoXOLD',
    'DynamicDiscs2023_Pack1_Felon',
    'DynamicDiscs2023_Pack1_Marshal',
    'DynamicDiscs2023_Pack1_Raider',
    'Latitude642023_Pack1_BallistaPro',
    'Latitude642023_Pack1_Claymore',
    'Latitude642023_Pack1_Flow',
    'SummerPack2023_Beach_Ball',
    'SummerPack2023_Destiny',
    'SummerPack2023_Sunset',
    'GlowArea64',
    'GlowDragon',
    'GlowJelly',
    'SilverLatt2023Rive',
    'SilverLatt2023Explorer',
    'RebeccaCoxGlory2023',
    'RebeccaCoxHonor2023',
    'EagleMcMahonRainmaker2023',
    'EagleMcMahonCloudBreaker2023',
    'MattyOStag2023',
    'MattyOEnforcer2023',
    'Maythe4th2023_Disc_1',
    'Maythe4th2023_Disc_2',
    'Maythe4th2023_Disc_3',
    'Trilogy_Challenge_Discs_2023_Champion',
    'Trilogy_Challenge_Discs_2023_Pure',
    'Trilogy_Challenge_Discs_2023_Vandal',
    'Trilogy_Challenge_Discs_2023_Warship',
    'Westside_Rumble_2023_Winner',
    'Season001_1_MPS1_Champion',
    'Season001_2_MPS1_Expert',
    'Season001_3_MPS1_Prospect',
    'Season001_4_MPS1_Rookie',
    'Season001_5_Top25',
    'Season001_6_Winner',
    'Season002_Reward_0_Flow',
    'Hops_2023_Slamboree_Game_Discs_1',
    'Hops_2023_Slamboree_Game_Discs_2',
    'Hops_2023_Slamboree_Game_Discs_3',
    'Season002_Reward_0_Flow',
    '2023_Independence_Day_Alien',
    '2023_Independence_Day_Eagle',
    '2023_Independence_Day_Fireworks',
    'IkigaiEnso2023_Samurai',
    'IkigaiEnso2023_Sunset',
    'Rainbow4',
    'Rainbow5',
    'Rainbow6',
    'Season002_Reward_1_Harp',
    'Season002_Reward_2_River',
    'OLDRainbow1',
    'S2_Multiplayer_Reward_Track_Escape',
    'S2_Multiplayer_Reward_Track_Harp',
    'Rainbow1',
    'S2_Multiplayer_Reward_Track_Shield',
    'S2_Multiplayer_Reward_Track_Svea',
    'GlowReward_Track_Ballista',
    'GlowReward_Track_River',
    'BatRed',
    'S2_Multiplayer_Reward_Track_Sapphire',
    'Lightning1',
    'S3_Multiplayer_Reward_Track_Essence',
    'S3_Multiplayer_Reward_Track_Hope',
    'S3_Multiplayer_Reward_Track_EmacJudge',
    'GlowOrigin',
    'S3_Multiplayer_Reward_Track_Falk',
    'GlowTursas',
    'S3_Multiplayer_Reward_Track_Captain',
    'S3_Multiplayer_Reward_Track_Captain',
    'Season002_1_Champion',
    'Season002_2_Expert',
    'Season002_3_Prospect',
    'Season002_4_Rookie',
    'Season002_5_Top25',
    'Season002_6_Winner',
    'SkullBlueer',
    'MouthGreen',
    'WebBW',
    '2023_First_Editions_Bite',
    '2023_First_Editions_Evidence',
    '2023_First_Editions_Sampo',
    '2023_Back_To_School_Science',
    '2023_Back_To_School_PhysEd',
    '2023_Back_To_School_Arts',
    'AldenFX22023',
    'AldenPA12023',
    'IsaacArchive2023',
    'IsaacX12023',
    'GlowRask',
    'GlowSpike',
    'S4_Multiplayer_Reward_Track_Sampo',
    'S4_Multiplayer_Reward_Track_Marlin',
    'S4_Multiplayer_Reward_Track_Fuse',
    'S4_Multiplayer_Reward_Track_Crab',
    'S4_Multiplayer_Reward_Track_Captain',
    'S4_Multiplayer_Reward_Track_Agent',
    'WolfGrey2',
    'KristinTattar2023_GS',
    'KristinTattar2023_KT',
    'KristinTattar2023_WC',
    'Season003_1_Champion',
    'Season003_2_Expert',
    'Season003_3_Prospect',
    'Season003_4_Rookie',
    'Season003_5_Top25',
    'Season003_6_Winner',
    'FirePack2023Firesign',
    'FirePack2023Phoenix',
    'FirePack2023Trust',
    'Halloween2023Ghosts',
    'Halloween2023Monster',
    'Halloween2023Vampire',
    'DiscmaniaGreen_DGV',
    'DiscmaniaRed_DGV',
    'DiscmaniaGold_DGV',
    'Ice10',
    'Ice11',
    'Ice12',
    'UliFoundation2023_Challenger',
    'UliFoundation2023_Raptor',
    'UliFoundation2023_AvengerSS',
    'PaulMcBeth2023Hades',
    'PaulMcBeth2023Malta',
    'Elemental2_Zeus',
    'Elemental2_Sapphire',
    'Elemental2_River',
    'dragonpack_zeus',
    'dragonpack_essence',
    'dragonpack_skygod',
    'Season004_1_Champion',
    'Season004_2_Expert',
    'Season004_3_Prospect',
    'Season004_4_Rookie',
    'Season004_5_Top25',
    'Season004_6_Winner',
    'S5_Multiplayer_Reward_Track_Bear',
    'S5_Multiplayer_Reward_Track_MD1',
    'S5_Multiplayer_Reward_Track_EmacTruth',
    'S5_Multiplayer_Reward_Track_Manta',
    'S5_Multiplayer_Reward_Track_Sapphire',
    'S5_Multiplayer_Reward_Track_Paradigm',
    'GlowSeason',
    'RedGlow',
    'BlueGlow',
    'skipper_explorer',
    'skipper_musket',
    'skipper_sapphire',
    'skipper_rive',
    'AlignmentBasic',
    'AlignmentRare',
    'S6_Multiplayer_Reward_Track_Maverick',
    'S6_Multiplayer_Reward_Track_Enigma',
    'S6_Multiplayer_Reward_Track_Honor',
    'S6_Multiplayer_Reward_Track_Hatchet',
    'S6_Multiplayer_Reward_Track_Maiden',
    'Season005_6_Winner',
    'Season005_5_Top25',
    'Season005_4_Rookie',
    'Season005_3_Prospect',
    'Season005_2_Expert',
    'Season005_1_Champion',
    'RoyalBraveBlack',
    'RoyalBraveTeal',
    'RoyalStriveRed',
    'RoyalStrivePink',
    'RoyalStriveBlue',
    'RoyalBravePink',
    'checkmate_queen',
    'checkmate_fuse',
    'checkmate_trust',
    'ReflectivityDebugBasic',
    'ReflectivityDebugPattern',
    'Season006_1_Champion',
    'Season006_2_Expert',
    'Season006_3_Prospect',
    'Season006_4_Rookie',
    'Season006_5_Top25',
    'Season006_6_Winner',
    'S6_Multiplayer_Reward_Track_EnigmaGlossRare',
    'S6_Multiplayer_Reward_Track_EnigmaGlossPatt',
    'S7_Multiplayer_Reward_Track_1',
    'S7_Multiplayer_Reward_Track_2',
    'S7_Multiplayer_Reward_Track_4',
    'S7_Multiplayer_Reward_Track_6',
    'S7_Multiplayer_Reward_Track_7',
    'S7_Multiplayer_Reward_Track_8',
    'KristinT2024Grace',
    'KristinT2024Pure',
    'LinusC2024Compass',
    'LinusC2024Strive',
    'SilverL2024Rive',
    'JakubS2024BallistaPro',
    'JakubS2024Brave',
    'SilverL2024Explorer',
    'Elemental3AirMD1',
    'Elemental3AirMusket',
    'Elemental3AirEnigma',
    'Paul_McBeth_Foundation_Pack_2_Anax',
    'Paul_McBeth_Foundation_Pack_2_Athena',
    'Luke2023RekoX',
    'GannonB2024MD5',
    'GannonB2024Prototype',
    'AldenH2024Mutant',
    'AldenH2024FD3',
    'KyleK2024Logic',
    'KyleK2024Vanguard',
    'EllaH2024FD',
    'EllaH2024Origin',
    'S8_Multiplayer_Reward_Track_1',
    'S8_Multiplayer_Reward_Track_2',
    'S8_Multiplayer_Reward_Track_3',
    'S8_Multiplayer_Reward_Track_4',
    'S8_Multiplayer_Reward_Track_5',
    'S8_Multiplayer_Reward_Track_6',
    'S8_Multiplayer_Reward_Track_8',
    'Season007_1_Champion',
    'Season007_2_Expert',
    'Season007_3_Prospect',
    'Season007_4_Rookie',
    'Season007_5_Top25',
    'Season007_6_Winner',
    'S9_Multiplayer_Reward_Track_1',
    'S9_Multiplayer_Reward_Track_2',
    'S9_Multiplayer_Reward_Track_3',
    'S9_Multiplayer_Reward_Track_4',
    'S9_Multiplayer_Reward_Track_5',
    'S9_Multiplayer_Reward_Track_6',
    'S9_Multiplayer_Reward_Track_7',
    'S9_Multiplayer_Reward_Track_8',
    'S9_Multiplayer_Reward_Track_Free_1',
    'Season008_1_Champion',
    'Season008_2_Expert',
    'Season008_3_Prospect',
    'Season008_4_Rookie',
    'Season008_5_Top25',
    'Season008_6_Winner',
    'Elemental4EarthStrive',
    'Elemental4EarthFD3',
    'Elemental4EarthHope',
    'RickyW2024General',
    'RickyW2024Truth',
    'KonaM2024Trespass',
    'KonaM2024Maverick',
    'MattO2024Prince',
    'MattO2024Sampo',
    'Sai2024Longbowman',
    'Sai2024Harp',
    'PinkGlow',
    'MVPOpen2024_Rhythm',
    'Halloween_2024_Medusa',
    'Halloween_2024_Mummy',
    'Halloween_2024_Scarecrow',
    'GlowPack2024Alien',
    'GlowPack2024DGV',
    'GlowPack2024Necro',
    'MVPOpen2024_Parachute',
    'MVPOpen2024_Shift',
    'MVPOpen2024_Tempo',
    'MVPOpen2024_Watt',
    'MVPOpen2024_Tempo_Glow',
    'MVPOpen2024_Shift_Purple',
    'MVPOpen2024_Watt_Blue',
    'MVPOpen2024_Watt_Red',
    'MVPOpen2024_Rhythm_Green',
];
